import React from 'react';
import officials from '../data/officials.json';
import ProfileCard from './ProfileCard';

const ProfileCardsSection = () => {
  // Separate Chaudhary Charan Singh from the rest of the officials
  const ccsProfile = officials.find(o => o.id === 'ccs');
  const otherOfficials = officials
    .filter(o => o.id !== 'ccs')
    .sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <section className="bg-slate-50 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-extrabold text-slate-800">Meet Our Village Officials</h2>
          <p className="mt-2 text-slate-600">Key contacts for village administration and development.</p>
        </div>

        {/* Special section for Chaudhary Charan Singh */}
        {ccsProfile && (
          <div className="mb-12 max-w-4xl mx-auto">
            <ProfileCard official={ccsProfile} variant="full" />
          </div>
        )}

        {/* Grid for other officials */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {otherOfficials.map(official => (
            <ProfileCard key={official.id} official={official} variant="simple" />
          ))}
        </div>

      </div>
    </section>
  );
};

export default ProfileCardsSection;
